import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

const SvgComponent = props => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 40" {...props}>
    <Path
      fill={props.color}
      d="M29.8 10.2l-10-10c-.2-.1-.4-.2-.6-.2H.8C.4 0 0 .4 0 .8v38.3c0 .5.4.9.8.9h28.3c.5 0 .8-.4.8-.8V10.8c.1-.2 0-.4-.1-.6zM7.5 11.7H15c.5 0 .8.4.8.8s-.4.8-.8.8H7.5c-.5 0-.8-.4-.8-.8s.3-.8.8-.8zm15 21.6h-15c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h15c.5 0 .8.4.8.8s-.3.8-.8.8zm0-5h-15c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h15c.5 0 .8.4.8.8s-.3.8-.8.8zm0-5h-15c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h15c.5 0 .8.4.8.8s-.3.8-.8.8zm0-5h-15c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h15c.5 0 .8.4.8.8s-.3.8-.8.8zm-4.2-6.6v-10l10 10h-10z"
    />
  </Svg>
);

export default SvgComponent;
